import { createContext } from 'react';
import type { Chord } from '@/lib/keys';

export interface ShortcutOptions {
  /** Human description shown in the shortcut cheatsheet / command palette. */
  description?: string;
  /** Fire even while a text field has focus. Default false. */
  allowInInput?: boolean;
  /** preventDefault + stopPropagation when it fires. Default true. */
  preventDefault?: boolean;
}

export interface ShortcutBinding extends ShortcutOptions {
  chord: Chord;
  handler: (event: KeyboardEvent) => void;
}

export interface ShortcutRegistry {
  register: (binding: ShortcutBinding) => () => void;
  /** Snapshot for a cheatsheet UI — not reactive, read it on open. */
  list: () => readonly ShortcutBinding[];
}

/** Lives in its own module so `ShortcutProvider.tsx` only exports a component. */
export const ShortcutContext = createContext<ShortcutRegistry | null>(null);
